import { NamedEntityDto } from './named.dto';

export class TreatmentDto extends NamedEntityDto {}
